import React, { useState } from 'react';
import SplashStep1 from './SplashStep1';
import { SplashStep2 } from './SplashStep2';
import { useUserProfile } from '../../../../customhooks/useUserProfile';
import SplashStep3 from './SplashStep3';

const InvestmentSplashScreen = ({
    setShowSplash
}: {
    setShowSplash: (val: boolean) => void;
}) => {
    const [loading, setLoading] = useState();
    const [step, setStep] = useState<1 | 2 | 3>(1);
    const [accountFound, setAccountFound] = useState(true); 
    const { userDetails } = useUserProfile();

    const stepList: Record<1 | 2 | 3, JSX.Element> = {
        1: <SplashStep1 onContinue={() => setStep(2)} />,
        2: (
            <SplashStep2
                onContinue={() => setStep(3)}
                userDetails={userDetails}
                accountFound={accountFound} 
                setAccountFound={setAccountFound} 
            />
        ),
        3: <SplashStep3 setShowSplash={setShowSplash} />
    };

    return (
        <section className='w-full h-max pt-20 flex justify-center'>
            <div className='w-[475px] bg-white rounded-xl flex flex-col items-center gap-4 p-8'>
                {stepList[step]}
            </div>
        </section>
    );
};
export default InvestmentSplashScreen;
